import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowLeft } from "lucide-react";
import { API } from "@/lib/api";
import { DEFAULT_SETTINGS } from "@/lib/constants";

export function usePublicSettings() {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  useEffect(() => {
    axios.get(`${API}/site`).then((r) => setSettings({ ...DEFAULT_SETTINGS, ...(r.data.settings || {}) })).catch(() => {});
  }, []);
  return settings;
}

export function LegalLayout({ title, children, testid }) {
  return (
    <div className="min-h-screen bg-cream text-ink font-sans" data-testid={testid}>
      <header className="border-b border-line bg-cream/90 backdrop-blur-md sticky top-0 z-40">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 h-[68px] flex items-center justify-between">
          <Link to="/" data-testid="legal-logo">
            <img src="/logo.png" alt="MARY SERVICES" className="h-8 w-auto" />
          </Link>
          <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-body2 hover:text-forest transition-colors" data-testid="legal-back">
            <ArrowLeft className="h-4 w-4" /> Retour au site
          </Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-14 sm:py-20">
        <h1 className="font-display font-semibold text-3xl sm:text-4xl tracking-tight" data-testid="legal-title">{title}</h1>
        <div className="mt-10 space-y-9 text-body2 text-base leading-relaxed [&_h2]:font-display [&_h2]:font-semibold [&_h2]:text-xl [&_h2]:text-ink [&_h2]:mb-3 [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:space-y-1.5">
          {children}
        </div>
      </main>
      <footer className="border-t border-line py-8 text-center text-xs text-muted2">
        © {new Date().getFullYear()} MARY SERVICES
      </footer>
    </div>
  );
}
